import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const ORANGE = "#E8470A";

function FAQItem({ faq, index, isOpen, onToggle }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06, ease: "easeOut" }}
      viewport={{ once: true, margin: "-40px" }}
      style={{
        borderRadius: "14px",
        overflow: "hidden",
        border: "1px solid #e5e7eb",
        backgroundColor: "#ffffff",
      }}
    >
      <button
        onClick={onToggle}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
          padding: "20px 24px",
          textAlign: "left",
          backgroundColor: isOpen ? "#fafaf9" : "#ffffff",
          border: "none",
          cursor: "pointer",
          transition: "background-color 0.15s",
        }}
      >
        <span style={{
          fontSize: "15px",
          fontWeight: 600,
          color: "#111827",
          lineHeight: 1.45,
        }}>
          {faq.question}
        </span>

        <motion.span
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.22, ease: "easeInOut" }}
          style={{
            flexShrink: 0,
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            backgroundColor: "rgba(232,71,10,0.1)",
            color: ORANGE,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            fontWeight: 300,
            lineHeight: 1,
          }}
        >
          +
        </motion.span>
      </button>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="answer"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.28, ease: "easeInOut" }}
            style={{ overflow: "hidden" }}
          >
            <div style={{ padding: "4px 24px 20px" }}>
              <p style={{
                fontSize: "14px",
                lineHeight: 1.7,
                color: "#6B7280",
                margin: 0,
              }}>
                {faq.answer}
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

export function FAQSection({ destination, faqs }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" style={{ padding: "40px 0 24px" }}>

      <motion.div
        initial={{ opacity: 0, y: 22 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: true, margin: "-80px" }}
        style={{ marginBottom: "32px", textAlign: "center" }}
      >
        <span style={{
          display: "block",
          color: ORANGE,
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.28em",
          textTransform: "uppercase",
          marginBottom: "12px",
        }}>
          Preguntas frecuentes
        </span>
        <h2 style={{
          fontSize: "clamp(22px, 3vw, 30px)",
          fontWeight: 800,
          color: "#111827",
          lineHeight: 1.2,
          margin: 0,
        }}>
          Todo lo que querés saber sobre {destination}
        </h2>
      </motion.div>

      <div style={{
        maxWidth: "680px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}>
        {faqs.map((faq, i) => (
          <FAQItem
            key={i}
            faq={faq}
            index={i}
            isOpen={openIndex === i}
            onToggle={() => setOpenIndex(openIndex === i ? null : i)}
          />
        ))}
      </div>
    </section>
  );
}
